import React from 'react';
import { HeaderIcon, IconSearch } from '@banhala/ui-kit';
import { bridge, useNavigator } from '../../utils';

interface SearchIconProps {
  screen: string;
}

export const SearchIcon: React.FC<SearchIconProps> = ({ screen }) => {
  const { navigator } = useNavigator();
  const handlePressIconSearch = () => {
    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_SEARCH',
      analytics: {
        SCREEN: screen,
      },
    });
    navigator.moveToSearch();
  };
  return (
    <HeaderIcon onPress={handlePressIconSearch}>
      <IconSearch />
    </HeaderIcon>
  );
};
